import React from 'react';
import type { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { MultiGrid } from './virtualization';
import Icon from '../Icon';

export const TableWrapper = styled.div`
  width: 100%;
`;

export const EmptyText = styled.p`
  text-align: center;
  padding: 16px 0;
`;
type GridPosition = {
  gridColumnStart: string;
  gridColumnEnd: string;
  gridRowStart: string;
  gridRowEnd: string;
};

type HeaderCellProps = HTMLAttributes<HTMLDivElement> & {
  grid?: GridPosition;
  isLeaf?: boolean;
  isDeepLeaf?: boolean;
};

export const HeaderCell = styled(
  ({ grid, isLeaf, isDeepLeaf, ...props }: HeaderCellProps) => (
    <div {...props} />
  ),
)<HeaderCellProps>`
  background: #e4ebf2;
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
  min-height: 35px;
  justify-content: center;
  border-right: 1px solid #c0ccd7;
  ${({ isDeepLeaf }: HeaderCellProps) =>
    isDeepLeaf &&
    css`
      &:not(:last-child) {
        // border-right: none;
      }
    `}
  ${({ isLeaf }: HeaderCellProps) =>
    !isLeaf &&
    css`
      border-bottom: 1px solid #c0ccd7;
    `}
  padding: 0 5px;
  box-sizing: border-box;
  ${({ grid }: HeaderCellProps) =>
    grid &&
    css`
      grid-column-start: ${grid.gridColumnStart};
      grid-column-end: ${grid.gridColumnEnd};
      grid-row-start: ${grid.gridRowStart};
      grid-row-end: ${grid.gridRowEnd};
    `}
`;

type HeaderCellTextProps = React.HTMLAttributes<HTMLParagraphElement> & {
  sticky?: boolean;
  isDeepLeaf?: boolean;
  center?: boolean;
};

export const HeaderCellText = styled(
  ({ sticky, isDeepLeaf, center, ...props }: HeaderCellTextProps) => (
    <p {...props} />
  ),
)<HeaderCellTextProps>`
  color: #4c4c4c;
  font-size: 12px;
  font-weight: bold;
  ${({ isDeepLeaf }: HeaderCellTextProps) =>
    isDeepLeaf &&
    css`
      color: #838d96;
      font-size: 11px;
      font-weight: normal;
    `}
  ${props =>
    props.center &&
    css`
      width: 100%;
      text-align: center;
    `}
  ${props =>
    props.sticky &&
    css`
      position: sticky;
      margin: 0 32px;
      width: auto;
      left: 16px;
      text-align: left;
    `}
`;
HeaderCellText.defaultProps = {
  center: true
};

type CellProps = HTMLAttributes<HTMLDivElement> & {
  index?: number;
};

export const Cell = styled(
  ({ index, ...props }: CellProps) => <div {...props} />,
)<CellProps>`
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #838383;
  position: relative;
`;

type HeaderWrapperProps = HTMLAttributes<HTMLDivElement> & {
  height?: number;
};

export const HeaderWrapper = styled(
  ({ height, ...props }: HeaderWrapperProps) => <div {...props} />,
)<HeaderWrapperProps>`
  ${props =>
    props.height &&
    css`
      height: ${props.height}px;
    `}
`;

export const HeaderVirtualizedGrid = styled(MultiGrid)`
  overflow: hidden !important;
  outline: none;

  & .ReactVirtualized__Grid__innerScrollContainer {
    display: grid;
  }
`;

type HeaderVirtualizedItemProps = HTMLAttributes<HTMLDivElement> & {
  widths?: string;
};

export const HeaderVirtualizedItem = styled(
  ({ widths, ...props }: HeaderVirtualizedItemProps) => <div {...props} />,
).attrs(() => ({
  style: (({ left, top }: { left: number; top: number }) => ({
    left,
    top,
  })) as any
}))<HeaderVirtualizedItemProps>`
  display: grid;
  ${({ widths }) =>
    widths &&
    css`
      grid-template-columns: ${widths};
    `}
`;

export const ArrowLeft = styled((props: Record<string, unknown>) => (
  <Icon type="small-arrow-left" {...props} />
))``;
export const ArrowRight = styled(ArrowLeft)`
  transform: rotate(-180deg);
`;
